import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { menuData } from "../data/MenuData";
import { Button } from "./Button";
import { FaBars } from "react-icons/fa";
import logo from "../video/breakfast.png";
import image from "../images/FooterImage.jpg";

const Nav = styled.nav`
  height: 100px;
  display: block;
  // background-color: rgba(280, 200, 29, 0.897);
  // background-color: rgba(237, 167, 29, 5);
  background-image: url(${image});
  justify-content: space-between;
  z-index: 100;
  position: sticky;
  width: 100%;
  border-style: inset;
  border-width: 15px;
  border-color: rgba(237, 167, 29, 0.897);
  right: 0;
`;

const NavLink = css`
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  text-decoration: none;
  font-size: 23px;
  &:hover {
    color: orange;
  }
`;

const Logo = styled(Link)`
  ${NavLink}
  color: #fff;
  font-style: italic;
  font-weight: bold;
  position: sticky;
`;

const MenuBars = styled(FaBars)`
  display: none;
  color: rgba(237, 167, 29, 0.897);

  @media screen and (max-width: 1300px) {
    display: block;
    background-image: url(${FaBars});
    background-size: contain;
    height: 30px;
    width: 40px;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: -5px;
    transform: translateY(25%);
    color: white;
  }
`;

const NavMenu = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  width: auto;
  min-width: max-content;

  @media screen and (max-width: 1600px) {
    left: 48%;
  }

  @media screen and (max-width: 1500px) {
    left: 46%;
  }

  @media screen and (max-width: 1400px) {
    left: 44%;
  }

  @media screen and (max-width: 1300px) {
    display: none;
  }
`;

const NavMenuLinks = styled(Link)`
  color: white;
  ${NavLink}
`;

const NavBtn = styled.div`
  display: flex;
  align-items: center;
  margin-right: 24px;
  text-decoration: none;

  @media screen and (max-width: 1300px) {
    display: none;
  }
`;

// Styled component for the Book Now button container - visible on all screen sizes, positioned for easy access
const NavBtns = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 80px;
  top: 50%;
  transform: translateY(-50%);
  
  @media screen and (max-width: 1300px) {
    right: 60px;
  }
  
  @media screen and (max-width: 768px) {
    right: 70px;
  }
`;

const Navbar = ({ toggle }) => {
  const [Navbar, setNavbar] = useState(false);
  const location = useLocation();

  const changeBackground = () => {
    if (window.pageYOffset >= 60) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    const watchScroll = () => {
      window.addEventListener("scroll", changeBackground);
    };

    watchScroll();

    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  let style = {
    display: location.pathname !== "/landing" ? "flex" : "relative",
    transition: "0.4s",
  };

  return (
    <Nav style={style}>
      <Logo to="/yadkinvalleywinecountry">
        <img
          src={logo}
          alt="logo"
          style={{
            position: "fixed",
            height: "140px",
            marginLeft: "80px",
            marginTop: "25px",
          }}
        />
      </Logo>
      <MenuBars style={{ marginRight: "40px" }} onClick={toggle} />
      <NavMenu>
        {menuData.map((item, index) => (
          <NavMenuLinks to={item.link} key={index}>
            {item.title}
          </NavMenuLinks>
        ))}
      </NavMenu>

      <NavBtns>
        <Button className="news-button" to="https://secure.thinkreservations.com/littleheavenbedandbreakfast/reservations" primary="true">
          <a id="news-letter" target="__blank" style={{textDecoration: "none"}} href="https://secure.thinkreservations.com/littleheavenbedandbreakfast/reservations" ><strong>Book Now</strong></a>
        </Button>
      </NavBtns>
    </Nav>
  );
};

export default Navbar;